import { render } from "./PosLeftbar.vue?vue&type=template&id=f6a9f03a&scoped=true"
import script from "./PosLeftbar.vue?vue&type=script&lang=js"
export * from "./PosLeftbar.vue?vue&type=script&lang=js"

import "./PosLeftbar.vue?vue&type=style&index=0&id=f6a9f03a&scoped=true&lang=css"
import "./PosLeftbar.vue?vue&type=style&index=1&id=f6a9f03a&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a9f03a"]])

export default __exports__